/*
 * @Descripttion: 
 * @Author: zhaozheng
 * @Version: 0.0.1
 * @Date: 2025-10-21 12:59:34
 * @LastEditors: zhaozheng
 * @LastEditTime: 2025-11-13 15:32:24
 */
import React, { Suspense, VFC } from 'react';
import * as THREE from 'three';
import { Canvas } from '@react-three/fiber';
import { Background } from './Background';

type TCanvasProps = {
  paletteA: [string, string, string];
  paletteB: [string, string, string];
  blend: number;
  modalOpen?: boolean;
};

export const TCanvas: VFC<TCanvasProps> = ({ paletteA, paletteB, blend, modalOpen = false }) => {
  const OrthographicCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, -10, 10);

  return (
    <Canvas
      camera={OrthographicCamera}
      dpr={window.devicePixelRatio}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        overflow: 'visible',
        pointerEvents: modalOpen ? 'none' : 'auto',
      }}
    >
      <Suspense fallback={null}>
        <Background
          position={[0.3, 0, 0]}
          paletteA={paletteA}
          paletteB={blend > 0 ? paletteB : paletteA}
          blend={blend}
        />
      </Suspense>
    </Canvas>
  );
};
